import { IonImg } from '@ionic/react';
import { useMemo } from 'react';

import styles from './StepSection.module.css';

interface StepSectionProps {
  image: string;
  title: string;
  description: string;
  index?: number;
}

export const StepSection = ({ image, title, description, index }: StepSectionProps) => {
  const descriptionWithHtml = useMemo(() => {
    // Replace *text* with <strong class="styles.strong">text</strong>
    let html = description.replace(/\*([^*]+)\*/g, (_, match) => `<strong>${match}</strong>`);

    // Replace _text_ with <i class="styles.italic">text</i>
    html = html.replace(/_([^_]+)_/g, (_, match) => `<i >${match}</i>`);
    return html;
  }, [description]);
  return (
    <div className={styles.step}>
      <div className={styles.stepInformation}>
        <div className={styles.stepIcon}>{index}</div>
        <div className={styles.stepText}>
          <h1 className={styles.title}>{title}</h1>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: descriptionWithHtml,
            }}
          />
        </div>
      </div>
      <div className={styles.visualContainer}>
        <IonImg className={styles.backgroundImage} src={image} />
      </div>
    </div>
  );
};
